import { Type } from "@sinclair/typebox";
import { IdSchema, JsonValueSchema, Sha256Schema, TimestampSchema } from "./shared.js";
export const GuideReviewSnapshotSchema = Type.Object({
    stage: Type.Union([Type.Literal("definition"), Type.Literal("canary")]),
    definitionId: IdSchema,
    contentDigest: Sha256Schema,
    traceDigest: Type.Union([Sha256Schema, Type.Null()]),
    validatorDigest: Type.Union([Sha256Schema, Type.Null()]),
    payload: JsonValueSchema,
    digest: Sha256Schema,
}, { additionalProperties: false });
export const GuideReviewBudgetSchema = Type.Object({
    maxChunkBytes: Type.Integer({ minimum: 512, maximum: 1024 * 1024 }),
    maxChunks: Type.Integer({ minimum: 1, maximum: 10000 }),
    maxOutputTokens: Type.Integer({ minimum: 1, maximum: 1000000 }),
    maxTotalTokens: Type.Integer({ minimum: 1, maximum: 100000000 }),
}, { additionalProperties: false });
/** 模型返回的定位只指向提供给该分段的冻结字段，不代表判断已获证实。 */
export const GuideReviewFindingSchema = Type.Object({
    findingId: IdSchema,
    pointer: Type.String({ maxLength: 65536 }),
    severity: Type.Union([Type.Literal("info"), Type.Literal("attention"), Type.Literal("high")]),
    category: Type.Union([
        Type.Literal("scope"),
        Type.Literal("handoff"),
        Type.Literal("criteria"),
        Type.Literal("failure"),
        Type.Literal("budget"),
        Type.Literal("evidence"),
        Type.Literal("other"),
    ]),
    description: Type.String({ minLength: 1, maxLength: 4000 }),
    reasoning: Type.String({ minLength: 1, maxLength: 4000 }),
    recommendation: Type.String({ minLength: 1, maxLength: 4000 }),
}, { additionalProperties: false });
export const GuideReviewChunkResultSchema = Type.Object({
    index: Type.Integer({ minimum: 0 }),
    chunkDigest: Sha256Schema,
    findings: Type.Array(GuideReviewFindingSchema, { maxItems: 128 }),
}, { additionalProperties: false });
export const GuideReviewModelOutputSchema = Type.Object({ kind: Type.Literal("reply"), semanticPayload: GuideReviewChunkResultSchema }, { additionalProperties: false });
export const GuideReviewFindingDecisionSchema = Type.Object({
    findingId: IdSchema,
    disposition: Type.Union([Type.Literal("acknowledged"), Type.Literal("disagree")]),
    reason: Type.String({ maxLength: 2000 }),
}, { additionalProperties: false });
export const GuideReviewSummarySchema = Type.Object({
    reviewId: IdSchema,
    stage: Type.Union([Type.Literal("definition"), Type.Literal("canary")]),
    status: Type.Union([
        Type.Literal("queued"),
        Type.Literal("running"),
        Type.Literal("cleaning"),
        Type.Literal("completed"),
        Type.Literal("failed"),
        Type.Literal("cancelled"),
        Type.Literal("stale"),
    ]),
    contentDigest: Sha256Schema,
    traceDigest: Type.Union([Sha256Schema, Type.Null()]),
    validatorDigest: Type.Union([Sha256Schema, Type.Null()]),
    snapshotDigest: Sha256Schema,
    resultDigest: Type.Union([Sha256Schema, Type.Null()]),
    seriesConfigDigest: Sha256Schema,
    modelConfigDigest: Sha256Schema,
    modelDisplayName: Type.String({ minLength: 1, maxLength: 255 }),
    modelDifference: Type.Literal("unknown"),
    independentContext: Type.Literal(true),
    coveredChunks: Type.Integer({ minimum: 0 }),
    totalChunks: Type.Union([Type.Integer({ minimum: 1 }), Type.Null()]),
    findings: Type.Array(GuideReviewFindingSchema, { maxItems: 512 }),
    failureCode: Type.Union([IdSchema, Type.Null()]),
    createdAt: TimestampSchema,
    updatedAt: TimestampSchema,
}, { additionalProperties: false });
export const GuideReviewSummaryListSchema = Type.Array(GuideReviewSummarySchema, { maxItems: 100 });
export const GuideReviewRetryResultSchema = Type.Object({ reviewId: IdSchema }, { additionalProperties: false });
//# sourceMappingURL=guide-review.js.map